// Pinned dashboards (or recent if none pinned).
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Star, LayoutDashboard, Layers, ArrowUpRight } from "lucide-react";

export default function PinnedDashboardsWidget() {
    const [items, setItems] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        api.get("/home/widget/pinned-dashboards")
           .then((r) => setItems(r.data || [])).catch(() => setItems([]));
    }, []);
    return (
        <div className="border border-border rounded-sm bg-card p-4 h-full" data-testid="home-widget-pinned-dashboards">
            <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-1.5">
                    <Star className="h-3.5 w-3.5 text-amber-500" fill="currentColor" strokeWidth={0} />
                    <span className="eyebrow text-[10px]">Your dashboards</span>
                </div>
                <button onClick={() => navigate("/dashboards")}
                        className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground hover:text-primary"
                        data-testid="home-pinned-dashboards-all">
                    See all →
                </button>
            </div>
            {items === null && <div className="text-xs text-muted-foreground">Loading…</div>}
            {items && items.length === 0 && (
                <div className="text-xs text-muted-foreground py-4 text-center">
                    No dashboards yet. <button onClick={() => navigate("/dashboards")} className="text-primary hover:underline">Create one</button>.
                </div>
            )}
            {items && items.length > 0 && (
                <ul className="space-y-1">
                    {items.map((d) => (
                        <li key={d.id}>
                            <button onClick={() => navigate(`/dashboards/${d.id}`)}
                                className="w-full group flex items-center gap-2.5 p-2 hover:bg-secondary/40 rounded-sm text-left"
                                data-testid={`home-pinned-${d.id}`}>
                                <LayoutDashboard className="h-3.5 w-3.5 text-muted-foreground shrink-0" strokeWidth={1.5} />
                                <div className="flex-1 min-w-0">
                                    <div className="text-sm truncate">{d.name}</div>
                                    <div className="text-[10px] font-mono text-muted-foreground uppercase tracking-wider flex items-center gap-2">
                                        {d.is_unified && <span className="inline-flex items-center gap-0.5 text-primary"><Layers className="h-2.5 w-2.5" />UNIFIED</span>}
                                        <span>· {d.widget_count} widgets</span>
                                    </div>
                                </div>
                                <ArrowUpRight className="h-3.5 w-3.5 text-muted-foreground opacity-0 group-hover:opacity-100" />
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
